import router from '@/router/index';
import qs from 'qs';
import user from '@/common/user';
import Config from '../../config';
import appConfig from '@/config';
import hjxApp from './hjxApp';
import hjxAppPro from './hjxAppPro';
import { Toast } from 'vant';

const jsCallApp = hjxApp;
const jsCallAppPro = hjxAppPro;
class App {
  constructor() {
    this.loading = window.appLoading || false;
  }
  /**
   * 调用原生打印功能
   * @param {*} param0（订单id）
   *            param1（门店地址）
   *            param2（产品名称）
   *            param3（回收金额）
   *            param4（门店库存号）
   *            param5（条形码）
   *            param5（门店名称）
   */
  doPrint({
    orderId = '',
    address = '',
    productName = '',
    amount = '',
    storageNum = '',
    coOrderId = '',
    storeName = ''
  }) {
    let doPrint = jsCallApp.doPrint;
    try {
      doPrint({
        orderId,
        address,
        productName,
        amount,
        storageNum,
        coOrderId,
        storeName
      });
    } catch (error) {
      Toast(error.message);
    }
  }
  /**
   * 登录态失效
   */
  logonStateFailure(retCode) {
    try {
      jsCallApp.logonStateFailure({
        retCode
      });
    } catch (error) {
      Toast(error.message);
    }
  }
  /**
   * 去订单详情
   */
  goOrderDetail({ query = {} }) {
    let skip2OrderDetail = jsCallApp.skip2OrderDetail;
    if (!skip2OrderDetail) throw new Error('skip2OrderDetail is not defined!');
    if (!query.orderId) throw new Error('orderId is not defined!');
    skip2OrderDetail({
      accessType: query.accessType,
      orderId: query.orderId,
      type: query.type,
      skipType: query.action,
      roleId: query.roleId
    });
  }
  /**
   * 获取通知栏高度
   * @param {*} { cb: 回调方法}
   */
  getStatusBarHeight(params) {
    try {
      const data = {
        cb: 'getBarH'
      };
      window.getBarH = params.cb;
      let getStatusBarHeight = jsCallApp.getStatusBarHeight;
      getStatusBarHeight && getStatusBarHeight(data);
    } catch (error) {
      console.log(error.message);
    }
  }
  /**
   * 显示loading弹框
   */
  showLoading() {
    try {
      if (this.loading) return;
      jsCallApp.showLoading();
      this.loading = true;
    } catch (error) {
      Toast(error.message);
    }
  }
  /**
   * 关闭loading弹框
   */
  closeLoading() {
    try {
      jsCallApp.closeLoading();
      this.loading = false;
    } catch (error) {
      Toast(error.message);
    }
  }
  blinkByRouter({ name = '', query = {}, params = '', type = 'push' }) {
    const routerParams = {
      name,
      query
    };
    if (params) {
      routerParams.params = params;
    }
    router[type](routerParams);
  }
  /**
   *
   * @param {*} name 路由path name => /name
   * @param {*} query 路由参数
   * @param {*} type 跳转方式
   */
  blinkByUrl({ name = '', query = {}, type = 'push' }) {
    const from = window.location.href;
    let params = Object.assign(user.getLoginInfo(), query);
    let to = `${window.location.origin}/${name}?${qs.stringify(params)}`;
    if (process.env.VUE_APP_BUILD_MODE !== 'development') {
      to = `${window.location.origin}${
        Config.baseUrl_production
      }${name}?${qs.stringify(params)}`;
    }

    // 和一级页面（apptab页）有跳转关系的路由需要处理
    const tabPage = appConfig.tabPage; // 一级页数组
    const fromFlag = !!tabPage.find(el => from.indexOf(el) > 0); // true 离开一级tab页
    const toFlag = !!tabPage.find(el => to.indexOf(el) > 0); // true 进入一级tab页
    if (process.env.VUE_APP_BUILD_MODE !== 'development') {
      try {
        if (fromFlag) {
          jsCallApp.toSubPage({
            url: to
          });
        } else if (toFlag) {
          jsCallApp.toTabPage({
            url: to
          });
        } else {
          router[type]({
            path: `/${name}`,
            query: params
          });
        }
      } catch (error) {
        Toast(error.message);
      }
    } else {
      router.push({
        path: `/${name}`,
        query: params
      });
    }
  }
  backByRouter(n = -1) {
    router.go(n);
  }
  /**
   * app返回
   */
  backByApp() {
    // if (process.env.VUE_APP_BUILD_MODE === 'development') {
    //   router.go(-1);
    //   return false;
    // }
    try {
      let skipBack = jsCallApp.skipBack;
      skipBack && skipBack();
      if (!skipBack) throw new Error('skipBack is not defined!');
    } catch (error) {
      router.go(-1);
    }
  }
  /**
   * GrowingIo 自定义事件上报
   * @param {*} eventId（事件标识符） number（事件的数值）eventLevelVariables（事件上报信息）。
   */
  reportDataByGroIo({ eventId = '', number = '', eventLevelVariables = '' }) {
    if (window.gio && eventId && eventLevelVariables) {
      if (number) {
        window.gio('track', eventId, number, eventLevelVariables);
      } else {
        window.gio('track', eventId, eventLevelVariables);
      }
    }
  }
  /**
   * 用浏览器跳转对应的链接
   * @param {string} url
   */
  downAppUrl(url) {
    let openDownloadUrl = jsCallApp.openDownloadUrl;
    openDownloadUrl &&
      openDownloadUrl({
        url
      });
    if (!openDownloadUrl) throw new Error('openDownloadUrl is not defined!');
  }
  /**
   * 获取门店信息，店员信息，手机品牌，手机型号，产品版本号
   * @param {*} functionName 回调方法名
   */
  getSystemInfo(functionName) {
    let getSystemInfo = jsCallApp.getSystemInfo;
    if (!getSystemInfo) throw new Error('getSystemInfo is not defined!');
    getSystemInfo &&
      getSystemInfo({
        cb: functionName
      });
  }
  /**
   * 订单数组去合并付款
   * @param {*} params
   */
  toMergePay(params) {
    try {
      let toMergePay = jsCallApp.toMergePay;
      if (!toMergePay) throw new Error('toMergePay is not defined!');
      toMergePay && toMergePay(params);
    } catch (error) {
      Toast(error.message);
    }
  }
  /**
   * 返回app主页
   * @param {*} params
   */
  backHome(params = {}) {
    try {
      let backHome = jsCallApp.backHome;
      if (!backHome) throw new Error('backHome is not defined!');
      backHome && backHome(params);
    } catch (error) {
      Toast(error.message);
    }
  }
  /**
   * app弹窗
   * @param {} '{title: 'xxx', subTitle: '', confirm: 'funName', cancel: 'funName'，cancelBtn: '取消', confirmBtn: '确认'}
   */
  messageBox(params) {
    try {
      window.phoneCall = params.confirm;
      window.phoneCancel = params.cancel;
      const obj = {
        title: '',
        subTitle: '',
        confirmBtn: '确认',
        cancelBtn: '取消'
      };
      const data = Object.assign({}, obj, params);
      data.confirm = 'phoneCall';
      data.cancel = 'phoneCancel';
      let messageBox = jsCallApp.messageBox;
      if (!messageBox) throw new Error('messageBox is not defined!');
      messageBox && messageBox(data);
    } catch (error) {
      Toast(error.message);
    }
  }
  /**
   * app扫描商品条码
   * @param {} '{callback: 'funName'}
   */
  scanQrcode(params) {
    try {
      const data = {
        cb: 'scanCallback'
      };
      window.scanCallback = params.callback;
      let scanQrcode = jsCallApp.scanQrcode;
      if (!scanQrcode) throw new Error('scanQrcode is not defined!');
      scanQrcode && scanQrcode(data);
    } catch (error) {
      Toast(error.message);
    }
  }
  /**
   * 订单列表跳转至指定功能
   * @param {} '{params: '{}'}
   */
  skip2OrderFun(params = {}) {
    try {
      let skip2OrderFun = jsCallApp.skip2OrderFun;
      skip2OrderFun(params);
    } catch (error) {
      Toast(error.message);
    }
  }
  /**
   * 获取app定位信息
   * @param {} '{params: '{callback: function}'}
   */
  getApplocation(params = {}) {
    try {
      const data = {
        cb: 'getApplocationCb'
      };
      window.getApplocationCb = params.callback;
      console.log(window.getApplocationCb);
      let getApplocation = jsCallApp.getApplocation;
      if (!getApplocation) throw new Error('getApplocation is not defined!');
      getApplocation(data);
    } catch (error) {
      Toast(error.message);
    }
  }
  /**
   * 向app存当前商户角色值
   * @param {} params: {value: ''}
   */
  setRoleType(params = {}) {
    try {
      let setRoleType = jsCallApp.setRoleType;
      if (!setRoleType) throw new Error('setRoleType is not defined!');
      setRoleType(params);
    } catch (error) {
      Toast(error.message);
    }
  }
  /**
   * 向app获取当前商户角色值
   * @param {} '{params: '{callback: function}'}
   */
  getRoleType(params = {}) {
    try {
      const data = {
        cb: 'getRoleTypeCb'
      };
      window.getRoleTypeCb = params.callback;
      let getRoleType = jsCallApp.getRoleType;
      if (!getRoleType) throw new Error('getRoleType is not defined!');
      getRoleType(data);
    } catch (error) {
      Toast(error.message);
    }
  }
  /**
   * 向app获取当前用户信息
   * @param {} '{params: '{callback: function}'}
   */
  getUserInfo() {
    try {
      const data = {
        cb: 'getUserInfoCb'
      };
      let getUserInfo = jsCallApp.getUserInfo;
      if (!getUserInfo) throw new Error('getUserInfo is not defined!');
      getUserInfo(data);
    } catch (error) {
      Toast(error.message);
    }
  }
  /**
   * 检测sdk-开始检测
   * @param {}
   */
  startDetect(params = {}) {
    try {
      let startDetect = jsCallApp.startDetect;
      if (!startDetect) throw new Error('startDetect is not defined!');
      startDetect(params);
    } catch (error) {
      Toast(error.message);
    }
  }
  /**
   * 检测sdk-修改检测结果
   * @param {}
   */
  modifyDetectResult(params = {}) {
    try {
      let modifyDetectResult = jsCallApp.modifyDetectResult;
      if (!modifyDetectResult)
        throw new Error('modifyDetectResult is not defined!');
      modifyDetectResult(params);
    } catch (error) {
      Toast(error.message);
    }
  }
  /**
   * 检测sdk-数据清除
   * @param {}
   */
  dataClear(params = {}) {
    try {
      let dataClear = jsCallApp.dataClear;
      if (!dataClear) throw new Error('dataClear is not defined!');
      dataClear(params);
    } catch (error) {
      Toast(error.message);
    }
  }
  /**
   * 检测sdk-拍照
   * @param {}
   */
  takeRealMachinePhoto(params = {}) {
    try {
      let takeRealMachinePhoto = jsCallApp.takeRealMachinePhoto;
      if (!takeRealMachinePhoto)
        throw new Error('takeRealMachinePhoto is not defined!');
      takeRealMachinePhoto(params);
    } catch (error) {
      Toast(error.message);
    }
  }
  /**
   * app扫描检测条码
   * @param {} '{callback: 'funName'}
   */
  scanSerialNum() {
    try {
      const data = {
        cb: 'scanSerialNumCb'
      };
      let scanSerialNum = jsCallApp.scanSerialNum;
      if (!scanSerialNum) throw new Error('scanSerialNum is not defined!');
      scanSerialNum && scanSerialNum(data);
    } catch (error) {
      Toast(error.message);
    }
  }
  get isIos() {
    return !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  }
  get isAos() {
    const u = navigator.userAgent;
    return u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
  }
  /**
   * 微信支付动作完回调
   * @param {} '{res: '1'}
   */
  wxPayResult(params = {}) {
    try {
      let wxPayResult = jsCallApp.wxPayResult;
      if (!wxPayResult) throw new Error('wxPayResult is not defined!');
      wxPayResult && wxPayResult(params);
    } catch (error) {
      Toast(error.message);
    }
  }
  /**
   * IOS使用-
   * @param {} '{prepayId: '1'}
   */
  getPayId(params = {}) {
    try {
      let getPayId = jsCallApp.getPayId;
      if (!getPayId) throw new Error('getPayId is not defined!');
      getPayId && getPayId(params);
    } catch (error) {
      Toast(error.message);
    }
  }
  /**
   * 拨打电话
   * @param {} '{tel: '1'}
   */
  appTel(params = {}) {
    try {
      let appTel = jsCallApp.appTel;
      if (!appTel) throw new Error('appTel is not defined!');
      appTel && appTel(params);
    } catch (error) {
      Toast(error.message);
    }
  }
  /**
   * app分享
   * @param {} '{title: '1', desc: '1', pic: '1', url: '1'}
   */
  appShare(params = {}) {
    try {
      let appShare = jsCallApp.appShare;
      if (!appShare) throw new Error('appShare is not defined!');
      appShare && appShare(params);
    } catch (error) {
      Toast(error.message);
    }
  }
  /*
   * 保存base64图片
   * @param { imageData: 'base64编码的图片数据' }
  */
  saveImage (params = {}) {
    let saveImage = jsCallAppPro.saveImage;
    if (!saveImage) throw new Error('saveImage is not defined!');
    saveImage && saveImage(params);
  }
  /*
   * 去设备详情
   * @param { sn: '质检流水号' }
  */
  skip2DetectV3Detail(params = {}) {
    let skip2DetectV3Detail = jsCallApp.skip2DetectV3Detail;
    if (!skip2DetectV3Detail) throw new Error('skip2DetectV3Detail is not defined!');
    skip2DetectV3Detail && skip2DetectV3Detail(params);
  }
}

export default new App();
